module.exports = __webpack_public_path__ + "img/start-icon.8e962282.svg";